import {IBookingManagementActionCreator,IBookingManagementActionTypes} from 'models/IBookingManagementState';

const initialState:any = {
    data:[]
}

const reducer = (state = initialState, { type, payload }: IBookingManagementActionCreator) => {
    switch (type) {
      case IBookingManagementActionTypes.FETCH_BOOKINGS_LIST_REQUEST:
        return {
          ...state,
          data:[],
        }
      case IBookingManagementActionTypes.FETCH_BOOKINGS_LIST_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;